import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonItemSliding, IonItem, IonItemOptions, IonItemOption, IonIcon } from '@ionic/angular';

import { CompanyLanguage } from '@ninety/mobile/platform/api';
import { TerraAvatarComponent, TerraHtmlSanitizerPipe, TerraNotificationCardModule } from '@ninety/terra';

import { NinetyNotification } from '../../models/ninety-notification.model';
import { ItemsNamePipe } from '../../pipes/items-name.pipe';
import { NotificationTitlePipe } from '../../pipes/notification-title.pipe';
import { TimeAgoPipe } from '../../pipes/time-ago.pipe';

@Component({
  selector: 'nty-notification-card',
  imports: [
    CommonModule,
    TerraNotificationCardModule,
    TerraAvatarComponent,
    TimeAgoPipe,
    NotificationTitlePipe,
    ItemsNamePipe,
    TerraHtmlSanitizerPipe,
    IonItemSliding,
    IonItem,
    IonItemOptions,
    IonItemOption,
    IonIcon,
  ],
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
})
export class NotificationCardComponent {
  @ViewChild('slidingItem') slidingItem!: IonItemSliding;

  @Input({ required: true }) notification!: NinetyNotification;
  @Input() language: CompanyLanguage | null = null;

  @Output() cardClick = new EventEmitter<void>();
  @Output() toggleReadStatus = new EventEmitter<void>();

  onToggleReadStatus(): void {
    this.toggleReadStatus.emit();
    this.slidingItem.close();
  }
}
